import { Module } from '@nestjs/common';
import { AiUsageService } from './ai-usage.service';

/**
 * Módulo compartido de medición de consumo de IA. Lo importan todos los módulos
 * que hacen llamadas a un LLM (ai-dashboard, ayuda-ia, cartera, tesorería, …)
 * para registrar tokens/costo en una fuente única de verdad (ai_consumo).
 * PrismaModule es @Global, por eso no hace falta importarlo acá.
 */
@Module({
  providers: [AiUsageService],
  exports: [AiUsageService],
})
export class AiUsageModule {}
